import React, { useState, useRef } from 'react';
import { Row, Col, Carousel, Grid } from 'antd';
import GalleryCard from 'components/GalleryCard';
import CarouselPagination from 'components/CarouselPagination';
import SeeMoreCard from 'components/SeeMoreCard';
import chunk from 'lib/chunkArray';

const GRID_COLS = 24;

const { useBreakpoint } = Grid;

interface Props {
    galleries: Gallery[];
    itemsPerRow?: number;
    seeMore?: boolean;
}

export const GalleriesCarousel = ({
    galleries,
    itemsPerRow = 4,
    seeMore = false
}: Props): React.ReactElement => {
    const [index, setIndex] = useState(0);
    const slider = useRef(null);
    const screens = useBreakpoint();

    const goNext = () => {
        slider.current.next();
    };

    const goPrevious = () => {
        slider.current.prev();
    };

    const slides = chunk<Gallery>(galleries, screens.md ? itemsPerRow : 2);
    return (
        <Row>
            <Col span={24}>
                <Carousel
                    autoplaySpeed={7000}
                    ref={slider}
                    dots={false}
                    afterChange={(index) => {
                        setIndex(index);
                    }}
                >
                    {slides.map((slide, i) => {
                        return (
                            <div key={`slide-${i}`}>
                                <Row gutter={24}>
                                    {slide.map((item) => (
                                        <Col
                                            key={item.seoSlug}
                                            md={GRID_COLS / itemsPerRow}
                                            xs={12}
                                        >
                                            <GalleryCard
                                                images={item.images}
                                                title={item.title}
                                                slug={item.seoSlug}
                                                category={item.category}
                                            />
                                        </Col>
                                    ))}
                                    {seeMore && slides.length === i + 1 && (
                                        <Col md={GRID_COLS / itemsPerRow} xs={12}>
                                            <SeeMoreCard url="/galerie" />
                                        </Col>
                                    )}
                                </Row>
                            </div>
                        );
                    })}
                </Carousel>
            </Col>
            <Col span={24}>
                <Row key={`pagination`}>
                    <Col span={24}>
                        <CarouselPagination
                            goNext={goNext}
                            goPrevious={goPrevious}
                            currentSlide={index}
                            slides={slides}
                        />
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

GalleriesCarousel.whyDidYouRender = false;

export default GalleriesCarousel;
